import type React from 'react'
import type { IconProps } from './types'

const PlusIcon: React.FC<IconProps> = ({ size = 20, className = 'stroke-current' }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={size}
		height={size}
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		className={`lucide lucide-plus-icon lucide-plus ${className}`}
		aria-hidden='true'>
		<path d='M5 12h14' />
		<path d='M12 5v14' />
	</svg>
)

export default PlusIcon
